import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const MyContentIcon = ({ className, color = Color.Red500 }: NewIconProps) => (
  <svg
    className={twMerge('size-[26px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="3" width="14" height="16" fill={color} />
    <rect x="8" y="21" width="12" height="2" fill={color} />
    <rect x="20" y="7" width="2" height="16" fill={color} />
  </svg>
);
